const regex = {
  point: new RegExp(/^[0-9\b]{0,13}$/),
};

export default regex;
